/**
 * Please design qty pricing:
 * 1st shirt = Please design price; extras = I have my own design price.
 */
(function () {
  var EXTRA_PROP = '_uc_design_extra';
  var busy = false;
  var queue = Promise.resolve();
  var origFetch = window.fetch.bind(window);

  function pairs() {
    return window.__ucDesignPairs || {};
  }

  function mergeDesignPairs(json) {
    try {
      var parsed = typeof json === 'string' ? JSON.parse(json || '{}') : json || {};
      window.__ucDesignPairs = Object.assign({}, window.__ucDesignPairs || {}, parsed);
    } catch (e) {}
  }

  window.__ucMergeDesignPairs = mergeDesignPairs;

  function ownIdFor(pleaseVariantId) {
    var map = pairs();
    return Number(map[String(pleaseVariantId)] || map[Number(pleaseVariantId)] || 0) || null;
  }

  function textHasPleaseDesign(text) {
    return String(text || '').toLowerCase().indexOf('please design') !== -1;
  }

  function textHasOwnDesign(text) {
    var t = String(text || '').toLowerCase();
    return t.indexOf('own design') !== -1 || t.indexOf('i have my own') !== -1;
  }

  function isPleaseDesignItem(item) {
    if (!item) return false;
    if (item.properties && item.properties[EXTRA_PROP]) return false;
    var parts = [].concat(item.variant_options || []).concat([item.variant_title, item.title]);
    if (textHasPleaseDesign(parts.join(' '))) return true;
    return !!ownIdFor(item.variant_id);
  }

  function isExtraItem(item) {
    return !!(item && item.properties && item.properties[EXTRA_PROP]);
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\?|$)/.test(String(url || '').split('#')[0]);
  }

  function isCartChangeUrl(url) {
    return /\/cart\/change(\?|$)/.test(String(url || '').split('#')[0]);
  }

  function syncPairsFromPage() {
    document.querySelectorAll('script[data-uc-design-pairs]').forEach(function (el) {
      mergeDesignPairs(el.textContent || '{}');
    });
  }

  function isPleaseVariantId(variantId) {
    if (ownIdFor(variantId)) return true;
    return false;
  }

  function fetchCart() {
    return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function cartAddJson(payload) {
    return origFetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function cartChangeJson(payload) {
    return origFetch((window.routes && routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function loadProduct(handle) {
    return origFetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      })
      .then(function (product) {
        mergePairsFromProduct(product);
        return product;
      });
  }

  function mergePairsFromProduct(product) {
    var opts = product.options || [];
    var designIdx = -1;
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name;
      if (String(name || '').toLowerCase().indexOf('design') !== -1) designIdx = i;
    }
    if (designIdx < 0) return;
    var key = 'option' + (designIdx + 1);
    var map = window.__ucDesignPairs || (window.__ucDesignPairs = {});
    (product.variants || []).forEach(function (please) {
      if (!textHasPleaseDesign(please[key])) return;
      (product.variants || []).forEach(function (own) {
        if (!textHasOwnDesign(own[key])) return;
        var ok = true;
        for (var o = 1; o <= 3; o++) {
          if (o === designIdx + 1) continue;
          if (String(please['option' + o] || '') !== String(own['option' + o] || '')) ok = false;
        }
        if (ok) map[String(please.id)] = own.id;
      });
    });
  }

  function productHandleFromItem(item) {
    if (item.handle) return item.handle;
    var m = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function resolveOwnId(pleaseVariantId, item) {
    var mapped = ownIdFor(pleaseVariantId);
    if (mapped) return Promise.resolve(mapped);
    var handle = item ? productHandleFromItem(item) : null;
    if (!handle) {
      handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      if (handle) handle = decodeURIComponent(handle);
    }
    if (!handle) return Promise.resolve(null);
    return loadProduct(handle).then(function () {
      return ownIdFor(pleaseVariantId);
    });
  }

  function copyProperties(srcProps) {
    var props = {};
    Object.keys(srcProps || {}).forEach(function (key) {
      if (!key || key.charAt(0) === '_') return;
      if (srcProps[key] == null || srcProps[key] === '') return;
      props[key] = srcProps[key];
    });
    props[EXTRA_PROP] = '1';
    props['Pricing note'] = 'Additional shirt(s) — same design (base price)';
    return props;
  }

  function propsFromFormData(fd) {
    var props = {};
    fd.forEach(function (value, key) {
      var m = String(key).match(/^properties\[(.*)\]$/);
      if (!m || !m[1] || m[1].charAt(0) === '_') return;
      if (value == null || value === '') return;
      props[m[1]] = value;
    });
    return props;
  }

  function findExtraLine(cart, ownVariantId, pleaseItem) {
    var pleaseReq = pleaseItem.properties && pleaseItem.properties['Design request'];
    for (var i = 0; i < (cart.items || []).length; i++) {
      var it = cart.items[i];
      if (Number(it.variant_id) !== Number(ownVariantId)) continue;
      if (!isExtraItem(it)) continue;
      if (
        pleaseReq &&
        it.properties &&
        it.properties['Design request'] &&
        it.properties['Design request'] !== pleaseReq
      ) {
        continue;
      }
      return it;
    }
    return null;
  }

  function cartJsonOk(data) {
    return !(data && (data.status || data.errors));
  }

  function getGroupTotal(pleaseItem, cart, ownId) {
    var extraQty = 0;
    if (ownId) {
      var extra = findExtraLine(cart, ownId, pleaseItem);
      extraQty = extra ? extra.quantity : 0;
    }
    return pleaseItem.quantity + extraQty;
  }

  /** Set please=1 and extra=(totalQty-1) for one design group */
  function applySplit(pleaseItem, totalQty) {
    totalQty = Math.max(0, parseInt(totalQty, 10) || 0);
    if (totalQty <= 0) {
      return cartChangeJson({ id: pleaseItem.key, quantity: 0 }).then(function (data) {
        return cartJsonOk(data);
      });
    }
    return resolveOwnId(pleaseItem.variant_id, pleaseItem).then(function (ownId) {
      if (!ownId) return false;
      var extraQty = totalQty - 1;
      return cartChangeJson({ id: pleaseItem.key, quantity: 1 }).then(function (data) {
        if (!cartJsonOk(data)) return false;
        return fetchCart().then(function (cart) {
          var extra = findExtraLine(cart, ownId, pleaseItem);
          if (extraQty <= 0) {
            if (!extra) return true;
            return cartChangeJson({ id: extra.key, quantity: 0 }).then(cartJsonOk);
          }
          if (extra) {
            return cartChangeJson({ id: extra.key, quantity: extraQty }).then(cartJsonOk);
          }
          return cartAddJson({
            id: ownId,
            quantity: extraQty,
            properties: copyProperties(pleaseItem.properties || {})
          }).then(cartJsonOk);
        });
      });
    });
  }

  function buildSplitChangeResponse(payload) {
    return refreshSectionsPayload(payload).then(function (sectionData) {
      return fetchCart().then(function (cart) {
        var data = {
          token: cart.token,
          note: cart.note,
          attributes: cart.attributes,
          original_total_price: cart.original_total_price,
          total_price: cart.total_price,
          total_discount: cart.total_discount,
          total_weight: cart.total_weight,
          item_count: cart.item_count,
          items: cart.items,
          requires_shipping: cart.requires_shipping,
          currency: cart.currency,
          items_subtotal_price: cart.items_subtotal_price,
          cart_level_discount_applications: cart.cart_level_discount_applications,
          sections: sectionData || {}
        };
        return new Response(JSON.stringify(data), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        });
      });
    });
  }

  function friendlyErrorResponse(payload, message) {
    return refreshSectionsPayload(payload).then(function (sectionData) {
      var data = { errors: message };
      if (sectionData) data.sections = sectionData;
      return new Response(JSON.stringify(data), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    });
  }

  function friendlyRemoveExtraMsg() {
    return (
      (window.cartStrings && window.cartStrings.ucDesignRemoveExtra) ||
      'Remove the additional shirt line first — then you can remove the design item.'
    );
  }

  function cartChangeRequest(payload) {
    return origFetch((window.routes && routes.cart_change_url) || '/cart/change', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload || {})
    }).then(function (res) {
      return res.text().then(function (text) {
        return ensureSectionsInResponse(text, payload, res.status);
      });
    });
  }

  function ensureSectionsInResponse(text, payload, status) {
    status = status || 200;
    try {
      var data = JSON.parse(text || '{}');
      var needsSections =
        payload &&
        payload.sections &&
        (!data.sections || !Object.keys(data.sections).length);
      if (!needsSections) {
        return new Response(mapCartErrorText(text), {
          status: status,
          headers: { 'Content-Type': 'application/json' }
        });
      }
      return refreshSectionsPayload(payload).then(function (sectionData) {
        if (sectionData) data.sections = sectionData;
        return new Response(mapCartErrorText(JSON.stringify(data)), {
          status: status,
          headers: { 'Content-Type': 'application/json' }
        });
      });
    } catch (e) {
      return new Response(mapCartErrorText(text), {
        status: status,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  }

  function changeWithSections(payload) {
    return cartChangeRequest(payload);
  }

  function mapCartErrorText(text) {
    if (!text) return text;
    try {
      var data = JSON.parse(text);
      var err = data.errors || data.description || data.message;
      if (err && /line parameter is invalid/i.test(String(err))) {
        data.errors = friendlyRemoveExtraMsg();
      }
      return JSON.stringify(data);
    } catch (e) {
      if (/line parameter is invalid/i.test(text)) return JSON.stringify({ errors: friendlyRemoveExtraMsg() });
      return text;
    }
  }

  function refreshSectionsPayload(payload) {
    if (!payload || !payload.sections) return Promise.resolve(null);
    var sections = payload.sections;
    if (Array.isArray(sections)) {
      sections = sections.filter(function (id, index, list) {
        return id && list.indexOf(id) === index;
      });
      sections = sections.join(',');
    }
    var path = payload.sections_url || window.location.pathname || '/';
    var url = path + (path.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(sections);
    return origFetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function finishCartChange(payload, runSync) {
    return cartChangeRequest(payload).then(function (res) {
      if (runSync !== false) setTimeout(scheduleSync, 80);
      return res;
    });
  }

  function handleAddWithSplit(url, config) {
    var body = config && config.body;
    if (!(body instanceof FormData)) return origFetch(url, config);

    syncPairsFromPage();

    var variantId = body.get('id');
    var qty = parseInt(body.get('quantity') || '1', 10) || 1;
    if (!variantId || qty <= 1) return origFetch(url, config);

    return resolveOwnId(variantId, null).then(function (ownId) {
      if (!ownId || !isPleaseVariantId(variantId)) return origFetch(url, config);

      var excess = qty - 1;
      var props = propsFromFormData(body);
      var sections = body.get('sections');
      var sectionsUrl = body.get('sections_url') || window.location.pathname;
      body.set('quantity', '1');

      busy = true;
      return origFetch(url, config)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status) {
            return new Response(JSON.stringify(data), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            });
          }
          return cartAddJson({
            id: ownId,
            quantity: excess,
            properties: copyProperties(props)
          }).then(function (extraData) {
            if (!cartJsonOk(extraData)) {
              return new Response(JSON.stringify(extraData), {
                status: 200,
                headers: { 'Content-Type': 'application/json' }
              });
            }
            return fetchCart().then(function (cart) {
              if (qty > 2 && typeof window.__ucShowCartNotice === 'function' && window.cartStrings) {
                window.__ucShowCartNotice(window.cartStrings.quantityError.replace('[quantity]', 1), {
                  eyebrow: window.cartStrings.ucNoticeEyebrow || 'Heads up',
                });
              }
              return refreshSectionsPayload({ sections: sections, sections_url: sectionsUrl }).then(function (sectionData) {
                data.item_count = cart.item_count;
                data.items = cart.items;
                data.total_price = cart.total_price;
                data.original_total_price = cart.original_total_price;
                data.items_subtotal_price = cart.items_subtotal_price;
                if (sectionData) data.sections = sectionData;
                return new Response(JSON.stringify(data), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' }
                });
              });
            });
          });
        })
        .finally(function () {
          busy = false;
        });
    });
  }

  function cartHasDesignItems(cart) {
    return (cart.items || []).some(function (item) {
      return isPleaseDesignItem(item) || isExtraItem(item);
    });
  }

  function handleChangeWithSplit(url, config) {
    var raw = config && config.body;
    if (typeof raw !== 'string') {
      return origFetch(url, config).then(function (res) {
        setTimeout(scheduleSync, 80);
        return res;
      });
    }

    syncPairsFromPage();

    var payload;
    try {
      payload = JSON.parse(raw);
    } catch (e) {
      return origFetch(url, config);
    }

    if (!payload.line || payload.quantity == null) {
      return origFetch(url, config).then(function (res) {
        setTimeout(scheduleSync, 80);
        return res;
      });
    }

    return fetchCart().then(function (cart) {
      var idx = payload.line - 1;
      var item = cart.items[idx];
      if (!item) return finishCartChange(payload);

      if (!isPleaseDesignItem(item) && !isExtraItem(item) && !cartHasDesignItems(cart)) {
        return finishCartChange(payload);
      }

      // Removing please design line while additional shirts exist
      if (isPleaseDesignItem(item) && !isExtraItem(item) && payload.quantity === 0) {
        busy = true;
        return resolveOwnId(item.variant_id, item)
          .then(function (ownId) {
            var extra = ownId ? findExtraLine(cart, ownId, item) : null;
            if (extra && extra.quantity > 0) {
              return friendlyErrorResponse(payload, friendlyRemoveExtraMsg());
            }
            return changeWithSections({
              id: item.key,
              quantity: 0,
              sections: payload.sections,
              sections_url: payload.sections_url
            });
          })
          .finally(function () {
            busy = false;
          });
      }

      // Extra shirt line — always use line item key (avoids stale line index)
      if (isExtraItem(item) && payload.quantity === 0) {
        busy = true;
        return changeWithSections({
          id: item.key,
          quantity: 0,
          sections: payload.sections,
          sections_url: payload.sections_url
        }).finally(function () {
          busy = false;
        });
      }

      // Please design qty → adjust combined total (please + matching extra lines)
      if (isPleaseDesignItem(item) && !isExtraItem(item) && payload.quantity > 0) {
        busy = true;
        return resolveOwnId(item.variant_id, item)
          .then(function (ownId) {
            if (!ownId) return false;
            var currentTotal = getGroupTotal(item, cart, ownId);
            var delta = payload.quantity - item.quantity;
            var newTotal = Math.max(1, currentTotal + delta);
            return applySplit(item, newTotal);
          })
          .then(function (splitOk) {
            if (splitOk === false) {
              return friendlyErrorResponse(
                payload,
                (window.cartStrings && window.cartStrings.ucCustomPricingFailed) ||
                  'We couldn\u2019t update custom pricing. Please refresh and try again.'
              );
            }
            return buildSplitChangeResponse(payload);
          })
          .finally(function () {
            busy = false;
          });
      }

      return finishCartChange(payload);
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    try {
      if (isCartAddUrl(url)) {
        return handleAddWithSplit(url, init || {});
      }
      if (isCartChangeUrl(url)) {
        return handleChangeWithSplit(url, init || {});
      }
    } catch (e) {
      if (Shopify?.designMode) console.warn('[uc-design-qty]', e);
    }
    return origFetch(input, init);
  };

  function sync() {
    if (busy) return Promise.resolve(false);
    busy = true;
    var changed = false;

    return fetchCart()
      .then(function (cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function (item) {
          if (!isPleaseDesignItem(item) || isExtraItem(item)) return;
          if (item.quantity <= 1) return;
          changed = true;
          chain = chain.then(function () {
            return resolveOwnId(item.variant_id, item).then(function (ownId) {
              var total = ownId ? getGroupTotal(item, cart, ownId) : item.quantity;
              return applySplit(item, total);
            });
          });
        });
        return chain.then(function () {
          return changed;
        });
      })
      .catch(function (err) {
        if (Shopify?.designMode) console.warn('[uc-design-qty]', err);
        return false;
      })
      .finally(function () {
        busy = false;
      });
  }

  function scheduleSync() {
    queue = queue
      .then(function () {
        return sync();
      })
      .then(function (changed) {
        if (
          changed &&
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'uc-design-qty' });
        }
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'uc-design-qty') return;
      setTimeout(scheduleSync, 120);
    });
  }

  function boot() {
    syncPairsFromPage();
    window.__ucDesignPairs = Object.assign({}, window.__ucDesignPairs || {});
    scheduleSync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__ucSyncDesignQty = scheduleSync;
})();
